import * as routes from '../actions/routing/route.actions'

const routePaths = {
    [routes.GOTO_HOME]: '/',
    [routes.GOTO_SETTINGS]: '/settings',
    [routes.GOTO_ADVENTURE]: '/adventure',
    [routes.GOTO_SQUAD]: '/squad',
    [routes.GOTO_UNIT]: '/unit/:unitID',
    [routes.GOTO_BATTLE]: '/battle/:battleStage',
    [routes.GOTO_BATTLE_RESULT]: '/battleResult',
}

export default routePaths
